import React from 'react';
import SectionTitle from './SectionTitle';

function PresentationClub() {
  return (
    <section className="section section--seam section--cream presentation-club" aria-labelledby="presentation-titre">
      <div className="presentation-club-inner">
        <SectionTitle overline="Le club" id="presentation-titre">
          Le tennis de table à Briançon
        </SectionTitle>

        <p>
          Le Tennis de Table Briançon est un club de sport associatif installé à Briançon,
          dans les Hautes-Alpes, la plus haute ville de France. Il réunit des joueuses et des
          joueurs de tous âges et de tous niveaux, du débutant qui découvre la raquette au
          compétiteur classé qui vise la montée. L'ambiance se veut conviviale : on vient
          d'abord pour le plaisir de jouer, échanger la balle et partager un moment ensemble.
        </p>

        <p>
          Le club ouvre plusieurs créneaux de jeu par semaine au Vieux gymnase des Garcins.
          Les séances sont libres : chacun vient jouer à son rythme, échange la balle et
          dispute des matchs avec les autres membres, avec du matériel mis à disposition pour
          celles et ceux qui débutent. On progresse au contact des joueurs plus expérimentés,
          dans une ambiance détendue.
        </p>

        <p>
          Sur le plan sportif, les équipes du TT Briançon sont engagées dans les championnats
          par équipes de la Fédération Française de Tennis de Table (FFTT). Les rencontres se
          disputent le week-end, à domicile comme à l'extérieur, contre les autres clubs de la
          région. Le classement des licenciés et le calendrier des prochaines rencontres sont
          consultables sur le site, mis à jour à partir des données officielles de la fédération.
        </p>

        <p>
          Que vous souhaitiez reprendre la compétition, vous remettre au sport ou simplement
          taper la balle entre amis, il y a une place pour vous à la table. La première séance
          d'essai est libre et sans engagement.
        </p>
      </div>
    </section>
  );
}

export default PresentationClub;
